import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'Templates'

const LandingFacadeTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
}

export const LandingFacade = ({ children }) => ( 
    <Suspense fallback={(
        <Loader />
    )}>
        {children}
    </Suspense>
)

LandingFacade.propTypes = LandingFacadeTypes
